<div class="rcp-bg-[#FAFAFA] rcp-font-openSans">
    <app-session-time-out></app-session-time-out>
    <app-toast></app-toast>
    <app-busy-progress></app-busy-progress>
    <div class="rcp-wrapper">
        @if (!isMF()) {
            <app-page-header></app-page-header>
        }

        <router-outlet />
    </div>
</div>
